import { createBrowserLogger } from "./implementations/browser.js";
export * from "./pinoModules.js";
export * from "./types.js";
export const ChildLoggers = new Map();
/**
 * The logging environment for this entry. Imported automatically by Vite instead of the index.ts
 */
export const ActiveLoggingEnvironment = "browser";
/**
 * The main logger shared by all Verdi packages in browser bundles.
 */
export const RootLogger = createBrowserLogger();
export function interceptLogOutput(_fn) {
    throw new Error('interceptLogOutput is not supported in the "browser" logging environment — ' +
        'it requires the test implementation (NODE_ENV === "test")');
}
//# sourceMappingURL=index.browser.js.map